module.exports = __webpack_public_path__ + "img/user_mind_lookcount.e10057d9.svg";